<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
    <kendo-grid-component
      :spanish="spanish"
      :dataResult='kendo.dataResult'
      :kendo="kendo"
      :loading='isGeneralLoading'
      :selectedField="selectedField"
      @datastatechange='dataStateChange'
      @columnreorder='columnReorder'
      @rowclick='openPath'
      @columnssubmit='onColumnsSubmit'
      @sortchange='sortChange'
      @filterchange='filterChange'
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange">
    </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="getAccionesPosibles !== null && getAccionesPosibles.length > 0 && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" :ariaHidden="true"/>
                {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
        </template>
      </base-footer>
      <BaseElDialog
        title="Borrar grupo"
        :visible.sync="showModal"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-group')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDeleteGroup }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-group">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/trash/GroupsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import { getGroups } from '@/services/configurations/groups/getGroups'
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
import { downloadGroupsExcel } from '@/services/configurations/groups/downloadGroupsExcel'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import { deleteTrashGroup } from '@/services/trash/deleteTrashGroup'
import { restoreTrashGroup } from '@/services/trash/restoreTrashGroup'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'

export default {
  name: 'vista-papelera-grupos',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    // UsersLinkTagsMultipleDialog,
    BaseElDialog,
  },
  data: function () {
    return {
      idVista: 46,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('trash.groups'),
        icon: 'trash',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'trashGroups',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 900, Descripcion: 'Borrar permanentemente' },
        { IdAccion: 901, Descripcion: 'Restaurar' }
      ],
      processMessageDeleteGroup: '¿Estás seguro que deseas borrar de forma permanente los grupos seleccionados?',
    }
  },
  computed: {
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    selectIcon: function (action) {
      return (action) =>
        action === 900 ? 'trash' 
          : 'restore'
    },
    getAccionesPosibles () {
      return this.listaAcciones
    },
  },
  watch: {
    $route (to, from) {
      this.updateOnRouteChange(to, from)
      // this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    },
  },
  created: async function () {
    
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.data = await this.applyFilters()
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.Nombre)
      this.$router.push({ name: 'trash/groups/details', params: { id: event.dataItem.IdGrupo } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)      
      // Fix temporal para mostrar columnas después de reordenar
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idGrupo: data.id ? data.id.value : null,
        nombre: data.name ? data.name.value : null,
        tipo: data.tipoGrupo ? data.tipoGrupo.value : null,
        VerTodoGrupos: data.verTodoGroups ? data.verTodoGroups.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        verTodoAsignarGrupos: data.verTodoAsignarGrupos ? data.verTodoAsignarGrupos.value : null, 
        emailGenerico: data.email ? data.email.value : null,
        numeroSMSGenerico: data.phone ? data.phone.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        enviarAvisosUsuarios: data.enviarAvisosUsuarios ? data.enviarAvisosUsuarios.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        borrados: true,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
        const payload = { order: objOrder.order, grupos: objColumnas }
        if (this.hasSelected) {
          const selectedIDs = this.selected.map(x => x.IdGrupo)
          payload.listaIDs = selectedIDs
        }
        const response = await downloadGroupsExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'grupos-borrados.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }
      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    updateOnRouteChange: async function (to, from) {
      await this.applyFilters()
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idGrupo: data.id ? data.id.value : null,
        nombre: data.name ? data.name.value : null,
        tipo: data.tipoGrupo ? data.tipoGrupo.value : null,
        VerTodoGrupos: data.verTodoGroups ? data.verTodoGroups.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        verTodoAsignarGrupos: data.verTodoAsignarGrupos ? data.verTodoAsignarGrupos.value : null, 
        emailGenerico: data.email ? data.email.value : null,
        numeroSMSGenerico: data.phone ? data.phone.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        enviarAvisosUsuarios: data.enviarAvisosUsuarios ? data.enviarAvisosUsuarios.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        borrados: true,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.Respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getGroups(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      data.Respuesta.forEach(o => {
        o.DiasAviso = o.DiasAviso === null ? 'Desactivado' : o.DiasAviso
        o.DiasFinTramite = o.DiasFinTramite === null ? 'Desactivado' : o.DiasFinTramite
      })
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 900) { // borrar
        this.deleteGroup()
      } else if (this.selectedAction.IdAccion === 901) { // recuperar
        this.restoreGroup()
      } else {
        console.error('Acción desconocida')
      }
    },
    restoreGroup: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idGrupos: []
        }
        for (const element of this.selected) {
          payload.idGrupos.push(element.IdGrupo)
        }
        const response = await restoreTrashGroup(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    deleteGroup: async function () {
      this.showModal = !this.showModal
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idGrupos: []
        }
        for (const element of this.selected) {
          payload.idGrupos.push(element.IdGrupo)
        }
        const response = await deleteTrashGroup(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
